import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';

import App from './components/App';
import Firebase, { FirebaseContext, FIREBASE_ENV } from './components/Firebase';

// Bandeau discret hors production, pour ne jamais confondre les environnements.
if (FIREBASE_ENV !== 'production') {
  const badge = document.createElement('div');
  badge.textContent = FIREBASE_ENV.toUpperCase();
  badge.style.cssText = 'position:fixed;bottom:8px;right:8px;z-index:9999;padding:2px 8px;font:500 11px Roboto,sans-serif;'
    + 'letter-spacing:1px;color:#000;background:#ffd400;border-radius:3px;pointer-events:none';
  document.body.appendChild(badge);
}

const root = createRoot(document.getElementById('root'));
root.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <App />
  </FirebaseContext.Provider>,
);

// Les anciens builds Create React App pouvaient enregistrer un service worker : on le désinstalle
// pour que les navigateurs des utilisateurs ne servent pas une version en cache.
navigator.serviceWorker?.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
